import { setHours, setMinutes } from 'date-fns';

export const roundUpTime = (date: Date) => {
  date.setSeconds(0);
  date.setMilliseconds(0);
  const minutes = date.getMinutes();
  if (minutes > 0 && minutes <= 15) {
    date.setMinutes(15);
  } else if (minutes > 15 && minutes <= 30) {
    date.setMinutes(30);
  } else if (minutes > 30 && minutes <= 45) {
    date.setMinutes(45);
  } else if (minutes > 45 && minutes <= 59) {
    date.setMinutes(0);
    date.setHours(date.getHours() + 1);
  }
  return date;
};
